const DEFAULT_MESSAGES = {
    capability: '当前订阅等级暂不支持此功能',
    quota: '当前订阅等级的功能使用次数已用尽'
};

export function showPermissionBlocked(reason = 'capability', context = {}) {
    const message = context.message || (
        reason === 'quota-exhausted' ? DEFAULT_MESSAGES.quota : DEFAULT_MESSAGES.capability
    );

    if (typeof window !== 'undefined') {
        const eventDetail = {
            message,
            reason,
            context
        };

        try {
            console.info('[billing] permission blocked', eventDetail);
            window.dispatchEvent(new CustomEvent('subscription:permission-blocked', { detail: eventDetail }));
        } catch (error) {
            console.warn('[permission] Failed to dispatch blocked event:', error);
        }

    } else {
        console.warn(`[permission] ${message}`, context);
    }
}
